export class EducationInformation {
    id: number;
    country: string;
    name: string;
    city: string;
    state: string;
    startDate: Date;
    endDate: Date;
}
